﻿$(function () {
    displayReadMore();
});

function displayReadMore() {
    var readmoretext = Bookhus.Localization.Standard.UI.GeneralText.Readmore;
    var readlesstext = Bookhus.Localization.Standard.UI.GeneralText.Readless;

    $('.line-clamp-6').each(function (index, item) {
        var $element = $(item);

        if ($element.next('.unclamp-container').length > 0) {
            return;
        }

        var scrollHeight = $element.prop('scrollHeight');
        var offsetHeight = $element.prop('offsetHeight');

        var fontSize = parseFloat(getComputedStyle(item).fontSize);
        var tolerance = fontSize * 1.5;

        if (scrollHeight - offsetHeight > tolerance) {

            var buttonContainer = $('<div/>', {
                'class': 'd-flex justify-content-center mb-2 unclamp-container'
            });

            var $button = $('<button/>', {
                'class': 'btn btn-link text-secondary',
                text: readmoretext + '...'
            });

            $button.on('click', function () {
                $element.toggleClass('unclamp');

                if ($element.hasClass('unclamp')) {
                    $button.text(readlesstext + '...');
                } else {
                    $button.text(readmoretext + '...');
                }
            });

            $button.appendTo(buttonContainer);
            $element.after(buttonContainer);
        }
    });
}